export const bundesligaFinale2026Meister = {
  "id": "bundesliga-finale-2026-sc-frankfurt-1880-meister",
  "title": "Bundesliga Finale 2026: SC Frankfurt 1880 krönt sich vor großer Kulisse zum Deutschen Meister",
  "slug": "bundesliga-finale-2026-sc-frankfurt-1880-meister",
  "publishedAt": "2026-06-14T09:00:00Z",
  "author": "Rugby Bundesliga Redaktion",
  "language": "de",
  "readTime": "4 min",
  "tags": [
    "Rugby",
    "Bundesliga",
    "Finale",
    "Deutsche Meisterschaft",
    "Hannover",
    "SC Frankfurt 1880",
    "SC Neuenheim"
  ],
  "excerpt": "Vor rund 3.000 Zuschauern im Beekestadion fand am 13. Juni 2026 das Finale der Rugby Bundesliga statt. Der SC Frankfurt 1880 setzte sich mit 35:10 gegen den SC Neuenheim durch und verteidigte eindrucksvoll seine Spitzenposition im deutschen Vereinsrugby.",
  "img": "/images/bundesliga-finale-2026-sc-frankfurt-1880-meister.jpeg",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Vor rund 3.000 Zuschauern im Beekestadion fand am 13. Juni 2026 das Finale der Rugby Bundesliga statt. Gastgeber Rugby Ricklingen hatte dem Endspiel einen Rahmen verliehen, wie er im deutschen Vereinsrugby nur selten zu erleben ist. Das Finale wurde zu einem echten Rugbyfest mit einer Atmosphäre, die dem sportlichen Anlass mehr als gerecht wurde und eindrucksvoll zeigte, welches Potenzial der Rugbysport in Deutschland besitzt."
    },
    {
      "type": "paragraph",
      "content": "Auch sportlich hielt die Partie, was sie versprach. Der SC Frankfurt 1880 und der SC Neuenheim präsentierten den Zuschauern das derzeit wohl beste Vereinsrugby Deutschlands und lieferten ein Finale auf hohem Niveau ab."
    },
    {
      "type": "paragraph",
      "content": "Der SC Frankfurt 1880 übernahm von Beginn an die Spielkontrolle und dominierte weite Strecken der Begegnung. Dennoch gelang es dem Titelverteidiger zunächst nicht, die Feldüberlegenheit konsequent in Punkte umzumünzen. Der SC Neuenheim hielt mit großer Leidenschaft dagegen. Besonders das präzise Kickspiel sowie die kompromisslose Verteidigung unmittelbar vor dem eigenen Malfeld sorgten dafür, dass die Heidelberger lange im Spiel blieben und den Favoriten immer wieder vor Herausforderungen stellten."
    },
    {
      "type": "paragraph",
      "content": "Die erste Halbzeit entwickelte sich zu einem intensiven Schlagabtausch. Neuenheim konnte durch einen Versuch von Nicolai Klewinghaus sowie dessen erfolgreiche Erhöhung zwischenzeitlich Akzente setzen. Frankfurt blieb jedoch geduldig und suchte konsequent nach Lücken in der Defensive des Gegners."
    },
    {
      "type": "paragraph",
      "content": "Ein entscheidender Moment der Begegnung war die verletzungsbedingte Auswechslung von Nicolai Klewinghaus. Der Ausfall des Spielmachers brachte einen spürbaren Bruch in das Neuenheimer Spiel. Frankfurt nutzte diese Phase eiskalt aus und legte noch vor der Pause mit zwei schnellen Versuchen den Grundstein für den späteren Erfolg."
    },
    {
      "type": "paragraph",
      "content": "Zu Beginn der zweiten Halbzeit verkürzte der SC Neuenheim zunächst per Straftritt auf 10 Punkte und setzte damit ein erstes Ausrufezeichen. Die Hoffnung auf eine Aufholjagd währte jedoch nur kurz. Frankfurt übernahm erneut die Kontrolle, bestimmte Tempo und Rhythmus der Partie und ließ keine echte Spannung mehr aufkommen."
    },
    {
      "type": "paragraph",
      "content": "Mit der Routine und Gelassenheit eines Serienmeisters spielte der SC Frankfurt 1880 die Begegnung souverän zu Ende. Weitere Versuche sorgten für klare Verhältnisse, ehe der Schlusspfiff den 35:10 Erfolg des Favoriten besiegelte. Damit verteidigten die Frankfurter eindrucksvoll ihre Spitzenposition im deutschen Vereinsrugby und wurden ihrer Favoritenrolle im Endspiel vollauf gerecht."
    },
    {
      "type": "paragraph",
      "content": "Das Bundesliga Finale bildete zugleich den würdigen Schlusspunkt einer bemerkenswerten 15er Saison 2025/26. Die Rugby Bundesliga setzt damit die positive Entwicklung der vergangenen Jahre fort. Im Rahmen der vor dem Finale abgehaltenen Sitzung der Rugby Bundesliga Ausschüsse bekannten sich die Vereine ausdrücklich zum aktuellen Ligasystem und verständigten sich auf verschiedene Weiterentwicklungen für die kommenden Spielzeiten. Ein ausführlicher Bericht zu den Ergebnissen der Sitzung wird zeitnah auf der Homepage veröffentlicht."
    },
    {
      "type": "paragraph",
      "content": "Mit dem Ende der 15er Saison richtet sich der Blick nun unmittelbar auf die kommende 7er Saison. Diese beginnt am 27. Juni mit den Qualifikationsturnieren in Berlin und München. Weitere Informationen und eine ausführliche Vorschau folgen in Kürze auf der Website der Rugby Bundesliga."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "SC Frankfurt 1880 35:10 SC Neuenheim"
    },
    {
      "type": "heading",
      "level": 3,
      "content": "SC Frankfurt 1880"
    },
    {
      "type": "list",
      "items": [
        "Versuche: Aidan Dixon, Leo John Wolf, Sebastian Rodwell, Edoardo Stella, Marcel Henn, Fabrizio Cabrera",
        "Erhöhung: Edoardo Stella (1)",
        "Straftritt: Edoardo Stella (1)"
      ],
      "ordered": false
    },
    {
      "type": "heading",
      "level": 3,
      "content": "SC Neuenheim"
    },
    {
      "type": "list",
      "items": [
        "Versuch: Nicolai Klewinghaus",
        "Erhöhung: Nicolai Klewinghaus (1)",
        "Straftritt: Finn Schwagger (1)"
      ],
      "ordered": false
    }
  ]
};
